import React, { Fragment, useEffect, useState, useRef } from "react";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { stateDistrictList } from "./StateDistrictList";
import { schoolBoardNamesList } from "./BoardNamesList";
import { degreeNamesList } from "./DegreeNamesList";
import Popup from "../Shared/Popup";
import { useSelector, useDispatch } from "react-redux";
import {
  uploadSingleFileToS3,
  uploadMultipleFilesToS3,
} from "../api/fileUploadApi";
import {
  studentSignup,
  getAdmissionPageInfo,
  saveRegistrationForm,
  getStudentProfile,
  completeRegistration,
  getStudentProfileForUpdateOnly,
  resetRegInfo
} from "../api/admissionApi";
import { updateAdmissionPageInfo } from "../../actions/admissionAction";
import FileUpload from "../common/FileUpload";
import LoaderSpinner from "../common/LoaderSpinner";
import { makeStyles } from "@mui/styles";
import { Nav, NavLink, NavItem } from "reactstrap";
import classnames from "classnames";

const initialValues = {
  registrationType: "",
  courseName: "--Select--",
  courseId: "",
  subjects: [],
  full_name: {
    first_name: "",
    middle_name: "",
    last_name: "",
  },
  father_name: "",
  mother_name: "",
  date_of_birth: "",
  gender: "--Select--",
  religion: "",
  category: "--Select--",
  isMinority: "--Select--",
  isEWS_category: "--Select--",
  nationality: "--Select--",
  annual_family_income: "",
  domicile: "",
  domicile_certitificate_number: "",
  isAadharAvailable: "--Select--",
  aadhar_number: "",
  special_category: "--Select--",
  state: "--Select--",
  district: "",
  address: "",
  pincode: "",
  isCorrespondenceAddressSame: false,
  correspondence_state: "",
  correspondence_district: "",
  correspondence_address: "",
  correspondence_pincode: "",
  mobile_number: "",
  email_id: "",
  intermediate_board_name: "",
  intermediate_roll_number: "",
  high_school_passing_year: "",
  high_school_board: "",
  high_school_roll_number: "",
  high_school_max_marks: "",
  high_school_marks_obtained: "",
  high_school_school_name: "",
  intermediate_passing_status: "",
  intermediate_isPassed: true,
  intermediate_passing_year: "",
  intermediate_max_marks: "",
  intermediate_marks_obtained: "",
  intermediate_school_name: "",
  graduation_state: "",
  graduation_passing_year: "",
  graduation_degree_earned_university: "",
  graduation_roll_number: "",
  graduation_max_marks: "",
  graduation_marks_obtained: "",
  post_graduation_state: "",
  post_graduation_passing_year: "",
  post_graduation_degree_earned_university: "",
  post_graduation_roll_number: "",
  post_graduation_max_marks: "",
  post_graduation_marks_obtained: "",
  qualifying_degree: "",
  enroll_roll_number: "",
  course_system: "",
  course_duration: "",
  weightage1: "",
  weightage2: [],
  // passport_photo: "", // file upload : has to be a string by default
  // signature: "", // file upload : has to be a string by default
  // category_certificate: "", // file upload : has to be a string by default -----------
  // domicile_certificate: "", // file upload : has to be a string by default
  // aadhar_card: "", // file upload : has to be a string by default
  // special_category_certificate: "", // file upload : has to be a string by default
  // EWS_category_certificate: "", // file upload : has to be a string by default
  document_urls: {
    passport_photo: "",
    signature: "",
    category_certificate: "",
    domicile_certificate: "",
    aadhar_card: "",
    special_category_certificate: "",
    EWS_category_certificate: ""
  }
};
const phoneRegExp = /[6789]{1}[0-9]{9}$/;
const useStyles = makeStyles((theme) => ({
  heading: {
    backgroundColor: "aliceblue",
    borderRadius: "10px 10px 10px 10px",
    maxHeight: "2rem",
    boxShadow: "0 3px 3px rgb(0 0 0 / 20%)",
    marginBottom: "10px",
    backgroundImage: "linear-gradient(to right bottom, #cfcfcf5c, #00000070)",
  },
}));
export default function StudentRegistration(props = {}) {
  const classes = useStyles();
  const {
    isStaffLogin,
    createUser,
    updateUserProfile,
    dispatchVerifyActions,
    creatingUser,
    updatingFaculty,
    verifyUser,
    verificationSuccess,
    isVerifyingUser,
    verifyApiCalled,
    permissions = {},
    isSuperAdmin,
  } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const state = useSelector((state) => state);
  const {
    dashboardReducer: { allSubjects = [] } = {},
    authenticationReducer: {
      login,
      studentProfile = {},
      userProfile = {},
    } = {},
    admissionReducer: {
      isAdmissionsOpen = false,
      admissionPageInfo = {},
      isFetchingExistingAdmsnPageInfo = false,
      isUserProfileLoading = false,
      isAdmissionPageInfoLoaded = false,
      admissionPageInfoFailed
    },
  } = state;
  const {
    // is_registration_completed = false,
    email_id = "",
    full_name = {},
    registration_for_course,
    isStudent = false,
    mobile_number = "",
    date_of_birth = "",
  } = studentProfile;
  const { info: { Bachelors = [], Masters = [] } = {}, registration_acceptance_time = {} } = admissionPageInfo;

  const [openEventPopup, setopenEventPopup] = useState(false);
  const [isRegistrationCompleted, setisRegistrationCompleted] = useState(null);
  const [formFilledCompletely, setformFilledCompletely] = useState(false);
  const [customPopupTitle, setcustomPopupTitle] = useState("");
  const [customPopupContent, setcustomPopupContent] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const currentYear = new Date().getFullYear();
  const [subjectsArr, setsubjectsArr] = useState([]);
  const [isRegistrationAcceptable, setisRegistrationAcceptable] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [callingApi, setCallingApi] = useState(true);
  const fileUploadRef = useRef(null);
  const [isDataAvailable, setisDataAvailable] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const [isOnlyUpdate, setIsOnlyUpdate] = useState(false);
  const [updateExistingRegUser, setUpdateExistingRegUser] = useState(false);
  const [existingAccountFetched, setExistingAccountFetched] = useState(false);
  const [studentEmail, setStudentEmail] = useState("");

  const uploadFiles = (e) => dispatch(uploadMultipleFilesToS3(e));
  const getStudProfile = (email, cbs) => dispatch(getStudentProfile(email, cbs));
  const getStudProfileForUpdateOnly = (email, cbs) => dispatch(getStudentProfileForUpdateOnly(email, cbs));

  const updateProfile = (e, cbs) => dispatch(saveRegistrationForm(e, cbs));
  const registerStudent = (e, cbs) => dispatch(completeRegistration(e, cbs));

  const isRegisteringForBachelors = registration_for_course === "Bachelors";
  const isRegisteringForMasters = registration_for_course === "Masters";

  const validateSchema = Yup.object().shape({
    registrationType: Yup.string()
      .required("Required")
      .oneOf(["Bachelors", "Masters"]),
    courseName: Yup.string().not(["--Select--"]).required("Required"),
    full_name: Yup.object().shape({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
    }),
    father_name: Yup.string().required("Required"),
    mother_name: Yup.string().required("Required"),
    date_of_birth: Yup.date().required("Required"),
    gender: Yup.string().not(["--Select--"]).required("Required"),
    religion: Yup.string().required("Required"),
    category: Yup.string().not(["--Select--"]).required("Required"),
    isMinority: Yup.string().not(["--Select--"]).required("Required"),
    isEWS_category: Yup.string().not(["--Select--"]).required("Required"),
    nationality: Yup.string().not(["--Select--"]).oneOf(["Indian", "others"]),
    annual_family_income: Yup.string()
      .min(1)
      .required("This field is required")
      .test(
        "Error:",
        "should be positive in number or zero",
        (value) => value >= 0
      ),
    domicile: Yup.string().required("Required"),
    domicile_certitificate_number: Yup.string().required("Required"),
    isAadharAvailable: Yup.string().not(["--Select--"]),
    special_category: Yup.string().not(["--Select--"]),
    state: Yup.string().not(["--Select--"]),
    district: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    pincode: Yup.string().required("Required"),
    isCorrespondenceAddressSame: Yup.boolean().oneOf([true, false]),
    correspondence_state: Yup.string().required("Required"),
    correspondence_district: Yup.string().required("Required"),
    correspondence_address: Yup.string().required("Required"),
    correspondence_pincode: Yup.string().required("Required"),
    mobile_number: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone number is required"),
    email_id: Yup.string()
      .email("Email must be a valid email address")
      .required("Email is required"),
    intermediate_board_name: Yup.string().required("Required"),
    intermediate_roll_number: Yup.string().required("Required"),
    high_school_passing_year: Yup.string().required("Required"),
    high_school_board: Yup.string().required("Required"),
    high_school_roll_number: Yup.string().required("Required"),
    high_school_max_marks: Yup.string().required("Required"),
    high_school_marks_obtained: Yup.string().required("Required"),
    high_school_school_name: Yup.string().required("Required"),
    intermediate_isPassed: Yup.boolean().oneOf([true, false]),
    intermediate_passing_year: Yup.string().required("Required"),
    intermediate_school_name: Yup.string().required("Required"),
    graduation_state: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().not(["--Select--"]).required("Required"),
    }),
    graduation_passing_year: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().required("Required"),
    }),
    graduation_degree_earned_university: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().required("Required"),
    }),
    graduation_roll_number: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().required("Required"),
    }),
    graduation_max_marks: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().required("Required"),
    }),
    graduation_marks_obtained: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string().required("Required"),
    }),
    post_graduation_state: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string(),
    }),
    post_graduation_passing_year: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string(),
    }),
    post_graduation_degree_earned_university: Yup.string().when(
      "registrationType",
      {
        is: "Masters",
        then: Yup.string(),
      }
    ),
    post_graduation_roll_number: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string(),
    }),
    post_graduation_max_marks: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string(),
    }),
    post_graduation_marks_obtained: Yup.string().when("registrationType", {
      is: "Masters",
      then: Yup.string(),
    }),
    weightage1: Yup.string().not(["--Select--"]).required("Required"),
    weightage2: Yup.array().min(1).required("Required"),
    aadhar_number: Yup.string().when("isAadharAvailable", {
      is: "Yes",
      then: Yup.string().min(12).max(14).required("Required"),
    }),
    intermediate_passing_status: Yup.string().when("registrationType", {
      is: "Bachelors",
      then: Yup.string().not(["--Select--"]),
    }),
    subjects: Yup.array()
      .nullable(true)
      .when(
        ["registrationType", "courseName"],
        (registrationType, courseName) => {
          if (registrationType === "Bachelors" && courseName === "BA")
            return Yup.array().min(3).required("Required");
        }
      ),
    intermediate_max_marks: Yup.string().when(
      ["intermediate_passing_status", "registrationType"],
      (intermediate_passing_status, registrationType) => {
        if (
          registrationType === "Masters" ||
          intermediate_passing_status === "Passed"
        ) {
          return Yup.string().required("Required");
        }
      }
    ),
    intermediate_marks_obtained: Yup.string().when(
      ["intermediate_passing_status", "registrationType"],
      (intermediate_passing_status, registrationType) => {
        if (
          registrationType === "Masters" ||
          intermediate_passing_status === "Passed"
        ) {
          return Yup.string().required("Required");
        }
      }
    ),
    // passport_photo: Yup.string().required("Required"),
    // signature: Yup.string().required("Required"),
    // category_certificate: Yup.string().when("category", {
    //   is: "scst",
    //   then: Yup.string().required("Required"),
    // }),
    // domicile_certificate: Yup.string(),
    aadhar_card: Yup.string().when("isAadharAvailable", {
      is: "Yes",
      then: Yup.string().required("Required"),
    }),
    // special_category_certificate: Yup.string().required("Required"),
    // EWS_category_certificate: Yup.string().when("isEWS_category", {
    //   is: "Yes",
    //   then: Yup.string().required("Required"),
    // }),
    document_urls: Yup.object().shape({
      passport_photo: Yup.string().required("Required"),
      signature: Yup.string().required("Required"),
      category_certificate: Yup.string().when("category", {
        is: "scst",
        then: Yup.string().required("Required"),
      }),
      domicile_certificate: Yup.string(),
      aadhar_card: Yup.string().when("isAadharAvailable", {
        is: "Yes",
        then: Yup.string().required("Required"),
      }),
      special_category_certificate: Yup.string().required("Required"),
      EWS_category_certificate: Yup.string().when("isEWS_category", {
        is: "Yes",
        then: Yup.string().required("Required"),
      })
    }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: () => handleFormSubmit()
  });

  const { values = {}, errors = {}, touched = {} } = formik;

  useEffect(() => {
    if (isRegisteringForMasters) {
      formik.setFieldValue("intermediate_passing_year", currentYear);
      formik.setFieldValue("high_school_passing_year", currentYear - 2);
      formik.setFieldValue("intermediate_passing_status", "Passed");
    }
    const callbacks = {
      successCallback: admissionPageInfoSuccess,
      failureCallback: admissionPageInfoFailure,
      isStudent,
      email_id,
      studentCallbacks: {
        successCallback: getStudentProfileSuccessCallback,
        failureCallback: getStudentProfileFailureCallback,
      }
    };
    dispatch(getAdmissionPageInfo({ year: moment(new Date()).format("YYYY") }, callbacks));

    return () => dispatch(resetRegInfo());
  }, []);

  useEffect(() => {
    if (isStudent && !isRegistrationCompleted && !callingApi) {
      if (email_id !== "") {
        formik.setFieldValue("email_id", email_id);
      }
      if (date_of_birth !== "") {
        formik.setFieldValue("date_of_birth", moment(date_of_birth).format("YYYY-MM-DD"));
      }
      if (full_name.first_name !== "") {
        formik.setFieldValue("full_name.first_name", full_name.first_name);
      }
      if (mobile_number !== "") {
        formik.setFieldValue("mobile_number", mobile_number);
      }
      if (registration_for_course === "Bachelors" || registration_for_course === "Masters") {
        formik.setFieldValue("registrationType", registration_for_course);
      }
    }
  }, [email_id, date_of_birth, full_name?.first_name, mobile_number, registration_for_course, isFetchingExistingAdmsnPageInfo]);

  useEffect(() => {
    if (Object.keys(registration_acceptance_time).length > 0) {
      setisRegistrationAcceptable(
        Object.keys(registration_acceptance_time).length > 0 &&
        new Date().getTime() >=
        new Date(registration_acceptance_time.start).getTime() &&
        new Date().getTime() <=
        new Date(registration_acceptance_time.end).getTime()
      );
    }
  }, [registration_acceptance_time]);

  useEffect(() => {
    if (values.isCorrespondenceAddressSame) {
      formik.setFieldValue("correspondence_state", values.state);
      formik.setFieldValue("correspondence_district", values.district);
      formik.setFieldValue("correspondence_address", values.address);
      formik.setFieldValue("correspondence_pincode", values.pincode);
    }
  }, [
    values.isCorrespondenceAddressSame,
    values.state,
    values.district,
    values.address,
    values.pincode,
  ]);

  useEffect(() => {
    if (Object.keys(admissionPageInfo).length <= 0) setisDataAvailable(false);
    else setisDataAvailable(true);
  }, [admissionPageInfo])

  const admissionPageInfoSuccess = (data) => {
    dispatch(updateAdmissionPageInfo(data));
  };

  const admissionPageInfoFailure = () => {
    toast.error("Some error occured, please try again!");
    setCallingApi(false);
  }

  const getStudentProfileSuccessCallback = (data) => {
    setCallingApi(false);
    setisRegistrationCompleted(data.profileDetails.is_registration_completed);
    delete data.profileDetails["password"];
    formik.setValues({ ...initialValues });
    formik.values = { ...initialValues };
    const newDataProfile = Object.assign(formik.values, data.profileDetails);
    formik.setValues({ ...newDataProfile });
    formik.setFieldValue("date_of_birth", moment(newDataProfile.date_of_birth).format("YYYY-MM-DD"));
    formik.setFieldValue("registrationType", data.profileDetails.registration_for_course);
    if (data.profileDetails.registration_for_course === "Masters") formik.setFieldValue("intermediate_passing_status", "Passed");
    if (
      data.profileDetails.subjects &&
      typeof data.profileDetails.subjects === typeof {}
    )
      setsubjectsArr(data.profileDetails.subjects);
    if (!data.profileDetails.is_registration_completed && !isOnlyUpdate) {
      toast.success("Last saved details loaded successfully.");
    } else if (!isStudent) {
      if (data.profileDetails.is_registration_completed) {
        toast.error("Registration is already completed for this user.");
        setExistingAccountFetched(true);
        setUpdateExistingRegUser(true);
      } else {
        toast.success("Account details loaded successfully.");
        setExistingAccountFetched(true);
      }
    }
  };
  const getStudentProfileFailureCallback = (errData) => {
    setCallingApi(false);
    if (errData !== undefined && errData.data) toast.error(errData.data.err);
    // MOMENT WHEN WRONG EMAIL ID IS PASSED OR SOME OTHER TECHNICAL ERROR OCCURED
    else alert("Error with your network, please try again!");
  };

  useEffect(() => {
    setformFilledCompletely(Object.keys(formik.errors).length < 1);
  }, [formik.errors]);

  useEffect(() => {
    if (formik.values.nationality === "others") {
      formik.setFieldValue("state", "");
    }
  }, [formik.values.nationality]);

  useEffect(() => {
    if (values.registrationType === "Masters" && values.courseName) {
      const found = Masters.find((course) => course.course_name === values.courseName);
      if (found) {
        formik.setFieldValue('courseId', found.course_id);
      }
    }

    if (values.registrationType === "Bachelors" && values.courseName) {
      const found = Bachelors.find((course) => course.course_name === values.courseName);
      if (found) {
        formik.setFieldValue('courseId', found.course_id);
      }
    }
  }, [values.courseName]);

  const handleFormSubmit = () => {
    if (!formFilledCompletely) {
      const keys = Object.keys(formik.initialValues);
      let dynamicPayload = {};
      if (keys.length) {
        keys.map((key) => {
          if (
            formik.initialValues[key] !== values[key] &&
            !formik.errors.key &&
            values[key] !== "" &&
            values[key] !== undefined
          ) {
            dynamicPayload[key] = values[key];
            return true;
          }
        });
      }
      dynamicPayload.email_id = email_id;
      const callbacks = {
        successCallback: profileUpdateSuccessCallback,
        failureCallback: profileUpdateFailureCallback,
      };
      updateProfile(dynamicPayload, callbacks);
    } else {
      const callbacks = {
        successCallback: studentRegistrationSuccessCallback,
        failureCallback: studentRegistrationFailureCallback,
      };
      updateProfile(formik.values, {
        successCallback: () => { registerStudent(email_id, callbacks); },
        failureCallback: () => {
          alert("Error in updating profile, try again!");
        },
      });
    }
  };
  const handleFormSubmitFaculty = () => {
    if (formFilledCompletely) {
      if (isOnlyUpdate) {

        if (updateExistingRegUser) {
          const callbacks = {
            successCallback: () => {
              toast.success("data updated successfully.");
            },
            failureCallback: () => {
              alert("Error in updating profile, try again!");
            },
          };
          updateProfile(formik.values, callbacks);
        } else {
          const callbacks = {
            successCallback: () => {
              if (studentEmail)
                registerStudent(studentEmail, {
                  successCallback: studentRegistrationSuccessCallback,
                  failureCallback: () => {
                    alert("Error registering this user, please try again!");
                  },
                });
            },
            failureCallback: () => {
              alert("Error in updating profile, try again!");
            },
          };
          if (studentEmail) updateProfile(formik.values, callbacks);
          else alert("Please enter student email id before submitting.");
        }
      } else {
        if (
          formik.values.registrationType &&
          formik.values.date_of_birth &&
          formik.values.full_name &&
          formik.values.mobile_number &&
          formik.values.email_id
        ) {
          const signUpPayload = {
            registration_for_course: formik.values.registrationType,
            date_of_birth: formik.values.date_of_birth,
            full_name: formik.values.full_name,
            mobile_number: formik.values.mobile_number,
            email_id: formik.values.email_id,
          };
          const callbacks = {
            successCallback: studentSignupSuccessCallback,
            errorCallback: () => {
              alert("Error creating account for the user, please try again!");
            },
          };
          dispatch(studentSignup(signUpPayload, callbacks));
        } else alert("Please fill the form first before submitting.");
      }
    } else alert("Please fill the form first before submitting.");
  };

  const studentSignupSuccessCallback = () => {
    toast.success("Student account created successfully!");
    const callbacks = {
      successCallback: () => {
        profileUpdateSuccessCallback();
        if (formik.values.email_id)
          registerStudent(formik.values.email_id, {
            successCallback: studentRegistrationSuccessCallback,
            failureCallback: () => {
              alert("Error registering this user, please ask the student to manually register by logging onto their dashboard.");
            },
          });
        else
          alert("Error registering this user, please ask the student to manually register by logging onto their dashboard.");
      },
      failureCallback: () => {
        alert("Error saving data for this user,  please ask the student to manually update their profile by logging onto their dashboard.");
      },
    };
    if (formik.values.email_id) updateProfile(formik.values, callbacks);
    else
      alert("Error updating profile, please ask the student to manually update and register by logging onto their dashboard.");
  };

  const profileUpdateSuccessCallback = (data) => {
    toast.success("Profile updated successfully");
  };
  const profileUpdateFailureCallback = (errData) => {
    toast.error("Profile update failed, try again!");
  };
  const studentRegistrationSuccessCallback = (data) => {
    toast.success(data.message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
    window.alert(`Your registration is successful. \nKindly note your form number: ${data.formNumber} \nPage will refresh in 3 seconds.`)
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };
  const studentRegistrationFailureCallback = (errData) => {
    toast.error("Registration failed, try again!");
  };

  const activeTabChangeHandler = (newTab) => {
    setStudentEmail("");
    setExistingAccountFetched(false);
    formik.setValues({ ...initialValues });
    setActiveTab(newTab);
    if (newTab === 2 && !isStudent) setIsOnlyUpdate(true);
    else setIsOnlyUpdate(false);
  };
  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">
                  Pre-Registration{" "}
                  {isRegisteringForBachelors ||
                    (isOnlyUpdate &&
                      existingAccountFetched &&
                      values.registrationType === "Bachelors")
                    ? "UG"
                    : isRegisteringForMasters ||
                      (isOnlyUpdate &&
                        existingAccountFetched &&
                        values.registrationType === "Masters")
                      ? "PG"
                      : "UG/PG"}{" "}
                  - Entrance Examination Form {currentYear}-{currentYear + 1}
                </h1>
              </div>
              {!isStudent && (
                <Nav tabs className="page-header-tab">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 1 })}
                      onClick={() => activeTabChangeHandler(1)}
                    >
                      New Registration
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 2 })}
                      onClick={() => activeTabChangeHandler(2)}
                    >
                      Update registration
                    </NavLink>
                  </NavItem>
                </Nav>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderFormTypeSection = () => {
    return (
      <Fragment>
        <div className="pl-10">
          <label className="text-danger" style={{ fontWeight: "600" }}>
            Account will be automatically created and registered once you click on save, kindly fill the form completely before submitting.
          </label>
          <br />
          {registration_acceptance_time.start && (<label className="text-danger" style={{ fontWeight: "600" }}>
            Registrations for student are acccepted from <span className="text-primary">{moment(registration_acceptance_time.start).format("DD-MMM-YYYY")}</span> till <span className="text-primary">{moment(registration_acceptance_time.end).format("DD-MMM-YYYY")}</span>
          </label>)}
        </div>
        <div className="card-header add">
          <h3 className="card-title">Registration for:</h3>
        </div>
        <div className="col-md-12 col-sm-12">
          <div className="col-md-6 col-sm-12 p-0">
            <Field
              as="select"
              name="registrationType"
              className="form-control"
              value={values.registrationType}
              onChange={(e) => {
                formik.setFieldValue("registrationType", e.target.value);
                formik.setFieldValue("courseName", "--Select--");
                formik.setFieldValue("subjects", []);
                formik.setFieldValue("courseId", '');
              }}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Bachelors">UG</option>
              <option value="Masters">PG</option>
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };

  const searchStudentProfile = () => {
    formik.setValues({ ...initialValues });
    const callbacks = {
      successCallback: getStudentProfileSuccessCallback,
      failureCallback: getStudentProfileFailureCallback,
    };
    if (!isStudent && studentEmail)
      getStudProfileForUpdateOnly(studentEmail, callbacks);
    else toast.error("You are not permitted to search student profile.");
  };

  const renderOnlyUpdateSection = () => {
    return (
      <Fragment>
        <div className="pl-10">
          <label className="text-danger" style={{ fontWeight: "600" }}>
            Only existing account's update will be done here, for new
            registrations go to{" "}
            <span
              onClick={() => activeTabChangeHandler(1)}
              style={{ textDecoration: "underline", cursor: "pointer", fontWeight: "bold" }}
            >
              previous
            </span>{" "}
            tab
          </label>
        </div>
        <div className="col-md-10 row" style={{ alignItems: "center" }}>
          <label className="col-form-label pl-10" style={{ width: "max-content" }}>
            Enter Student's email<span className="text-danger">*</span>
          </label>
          <div className="col-md-7">
            <input
              style={{ width: "100%" }}
              type="text"
              placeholder="Enter email id"
              className={`form-control`}
              value={studentEmail}
              onChange={(e) => setStudentEmail(e.target.value)}
              onKeyUp={(e) => { e.keyCode === 13 && searchStudentProfile(); }}
            />
          </div>
          <button
            id="search-user-btn"
            className="btn btn-primary col-md-2"
            disabled={!studentEmail || isUserProfileLoading}
            type="button"
            onClick={searchStudentProfile}
          >
            {" "}
            {isUserProfileLoading ? <LoaderSpinner /> : "Search profile"}
          </button>
        </div>
      </Fragment>
    );
  };

  const handleSubjectsRadioBtnClicks = (event) => {
    const group = event.target.id.charAt(event.target.id.length - 1);
    const value = event.target.value;
    let temp = [...subjectsArr];
    const isLengthThree = temp.length === 3;
    if (group === "1") {
      const isgeography = value === "geography";
      const ispsychology = value === "psychology";
      if (isgeography || ispsychology) {
        if (temp.includes("geography") && ispsychology) {
          temp = temp.filter((val) => val !== "geography");
          temp.push(value);
        } else if (temp.includes("psychology") && isgeography) {
          temp = temp.filter((val) => val !== "psychology");
          temp.push(value);
        } else if (
          (temp.includes("psychology") && ispsychology) ||
          (temp.includes("geography") && isgeography)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    } else if (group === "2") {
      const iseducation = value === "education";
      const ispoliticalScience = value === "politicalScience";
      if (iseducation || ispoliticalScience) {
        if (temp.includes("education") && ispoliticalScience) {
          temp = temp.filter((val) => val !== "education");
          temp.push(value);
        } else if (temp.includes("politicalScience") && iseducation) {
          temp = temp.filter((val) => val !== "politicalScience");
          temp.push(value);
        } else if (
          (temp.includes("education") && iseducation) ||
          (temp.includes("politicalScience") && ispoliticalScience)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    } else if (group === "3") {
      const ishindi = value === "hindi";
      const issociology = value === "sociology";
      if (ishindi || issociology) {
        if (temp.includes("hindi") && issociology) {
          temp = temp.filter((val) => val !== "hindi");
          temp.push(value);
        } else if (temp.includes("sociology") && ishindi) {
          temp = temp.filter((val) => val !== "sociology");
          temp.push(value);
        } else if (
          (temp.includes("hindi") && ishindi) ||
          (temp.includes("sociology") && issociology)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    } else if (group === "4") {
      const isurdu = value === "urdu";
      const issanskrit = value === "sanskrit";
      if (isurdu || issanskrit) {
        if (temp.includes("urdu") && issanskrit) {
          temp = temp.filter((val) => val !== "urdu");
          temp.push(value);
        } else if (temp.includes("sanskrit") && isurdu) {
          temp = temp.filter((val) => val !== "sanskrit");
          temp.push(value);
        } else if (
          (temp.includes("urdu") && isurdu) ||
          (temp.includes("sanskrit") && issanskrit)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    } else if (group === "5") {
      const isenglish = value === "english";
      const ishistory = value === "history";
      if (isenglish || ishistory) {
        if (temp.includes("english") && ishistory) {
          temp = temp.filter((val) => val !== "english");
          temp.push(value);
        } else if (temp.includes("history") && isenglish) {
          temp = temp.filter((val) => val !== "history");
          temp.push(value);
        } else if (
          (temp.includes("english") && isenglish) ||
          (temp.includes("history") && ishistory)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    } else if (group === "6") {
      const iseconomics = value === "economics";
      const isphilosophy = value === "philosophy";
      if (iseconomics || isphilosophy) {
        if (temp.includes("economics") && isphilosophy) {
          temp = temp.filter((val) => val !== "economics");
          temp.push(value);
        } else if (temp.includes("philosophy") && iseconomics) {
          temp = temp.filter((val) => val !== "philosophy");
          temp.push(value);
        } else if (
          (temp.includes("economics") && iseconomics) ||
          (temp.includes("philosophy") && isphilosophy)
        ) {
          temp = temp.filter((val) => val !== value);
        } else {
          !isLengthThree && temp.push(value);
        }
      } else return true;
    }
    setsubjectsArr(temp);
    formik.setFieldValue("subjects", temp);
  };

  const onBlurAadhar = (e) => {
    e.target.maxLength = 14;
    const val = values.aadhar_number;
    let newVal = "";
    if (val.length <= 4 && val.length !== 0) {
      newVal = `${val.slice(0, val.length)}`;
    }
    if (val.length !== 0 && val.length > 4 && val.length <= 8) {
      newVal = `${val.slice(0, 4)}-${val.slice(4, val.length)}`;
    }
    if (val.length > 8) {
      newVal = `${val.slice(0, 4)}-${val.slice(4, 8)}-${val.slice(8, val.length)}`;
    }
    formik.setFieldTouched("aadhar_number", true);
    formik.setFieldValue("aadhar_number", newVal);
  };

  const onFocusAadhar = (e) => {
    e.target.maxLength = 12;
    const val = values.aadhar_number;
    let newVal = "";
    if (val.length) {
      newVal = `${val.slice(0, 4)}${val.slice(5, 9)}${val.slice(10, 14)}`;
    }
    formik.setFieldValue("aadhar_number", newVal);
  };

  const updateFileUploadStatus = (newFiles, fieldName, uploadStatusObj) => {
    uploadStatusObj.uploading();
    if (newFiles) {
      const callbacks = {
        successCallback: fileUploadSuccessCallback,
        failureCallback: fileUploadFailureCallback,
      };
      dispatch(
        uploadSingleFileToS3(newFiles, fieldName, callbacks, uploadStatusObj)
      );
    }
  };

  const fileUploadSuccessCallback = (resp, fieldName, uploadStatusObj) => {
    const { link = "", fileCategory = "" } = resp;
    formik.setFieldValue(fileCategory, link);
    uploadStatusObj.uploadSuccess();
  };
  const fileUploadFailureCallback = (resp, uploadStatusObj) => {
    uploadStatusObj.uploadFailure();
  };

  const renderPersonalInfoSection = () => {
    let bachelorSubjects = '';
    let mastersSubjects = '';
    if (values.registrationType === "Masters" && values.courseName && values.courseId) {
      const selCourse = Masters.find(course => course.course_id === values.courseId);
      if (selCourse) {
        mastersSubjects = selCourse.subjects.join(', ');
      }
    }
    if (values.registrationType === "Bachelors" && values.courseName && values.courseId) {
      const selCourse = Bachelors.find(course => course.course_id === values.courseId);
      if (selCourse) {
        bachelorSubjects = selCourse.subjects.join(', ');
      }
    }
    return (
      <Fragment>
        <div className={`card-header add ${classes.heading}`}>
          <h3 className="card-title">Personal Information</h3>
        </div>

        {(values.registrationType === "Masters" ||
          values.registrationType === "Bachelors") && (
            <div className="col-md-12 mb-2">
              Courses: <span style={{ color: "red" }}>*</span>
            </div>
          )}

        {values.registrationType === "Masters" && (
          <Fragment>
            <div className="col-md-12 col-sm-12">
              <div className="form-group col-md-6">
                <label>Course Name</label>
                <Field
                  as="select"
                  name="courseName"
                  className={`form-control ${touched.courseName && errors.courseName ? "error" : ""}`}
                  placeholder="courseName"
                  value={values.courseName}
                >
                  <option default value="--Select--">{" "}--Select--{" "}</option>
                  {Masters?.length > 0 && Masters.map((val, index) => {
                    return (
                      <option key={`_${val.course_name}_${index}`} value={val.course_name}>
                        {val.course_name}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
            {values.registrationType === "Masters" &&
              values.courseName !== "--Select--" && (
                <div className="col-md-12 col-sm-12">
                  <div className="form-group col-md-6">
                    <Fragment>
                      <label>Subject(s)</label>
                      <div className="col-md-12 col-sm-12 pt-2" style={{ textTransform: 'capitalize' }}>
                        {formik.values.courseName !== "" && mastersSubjects}
                      </div>
                    </Fragment>
                  </div>
                </div>
              )}
          </Fragment>
        )}
        {values.registrationType === "Bachelors" && (
          <Fragment>
            <div className="col-md-12 col-sm-12">
              <div className="form-group col-md-6 col-sm-12">
                <label>Course Name</label>
                <Field
                  as="select"
                  name="courseName"
                  className={`form-control ${touched.courseName && errors.courseName ? "error" : ""}`}
                  placeholder="courseName"
                  value={values.courseName}
                >
                  <option default value="--Select--">
                    {" "}--Select--{" "}
                  </option>
                  <option value="BA">B.A.</option>
                  {Bachelors.length > 0 && Bachelors.map((val, index) => {
                    return (
                      <option key={`_${val.course_name}_${index}`} value={val.course_name}>
                        {val.course_name}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
          </Fragment>
        )}
        {values.courseName === "BA" && (
          <Fragment>
            <div className="col-md-12 col-sm-12">
              Subjects:&nbsp;
              <span style={{ color: "red" }}>
                *choose any 3 from below 6 groups
              </span>
              {values.subjects.length > 0 && (
                <span
                  className="pl-1 link ml-10"
                  onClick={() => {
                    setsubjectsArr([]);
                    formik.setFieldValue("subjects", []);
                  }}
                >
                  Reset
                </span>
              )}
            </div>

            <div className="col-md-12 col-sm-12 mt-2" onChange={handleSubjectsRadioBtnClicks}>
              <div className="col-md-12 col-sm-12" style={{ display: "flex", flexDirection: "row" }}>
                <div className="col-md-2 mb-2" style={{ textDecoration: "underline" }}>
                  Group 1:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("geography")]}`}
                    className="form-check-input"
                    type="radio"
                    value="geography"
                    id="group1"
                    checked={subjectsArr.includes("geography")}
                  />
                  <label>Geography</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("psychology")]
                      }`}
                    className="form-check-input"
                    type="radio"
                    value="psychology"
                    id="group1"
                    checked={subjectsArr.includes("psychology")}
                  />
                  <label>Psychology</label>
                </div>
              </div>

              <div
                className="col-md-12 col-sm-12"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="col-md-2 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Group 2:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("education")]}`}
                    className="form-check-input"
                    type="radio"
                    value="education"
                    id="group2"
                    checked={subjectsArr.includes("education")}
                  />
                  <label>Education</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("politicalScience")]}`}
                    className="form-check-input"
                    type="radio"
                    value="politicalScience"
                    id="group2"
                    checked={subjectsArr.includes("politicalScience")}
                  />
                  <label>Political Science</label>
                </div>
              </div>

              <div
                className="col-md-12 col-sm-12"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="col-md-2 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Group 3:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("hindi")]}`}
                    className="form-check-input"
                    type="radio"
                    value="hindi"
                    id="group3"
                    checked={subjectsArr.includes("hindi")}
                  />
                  <label>Hindi</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("sociology")]}`}
                    className="form-check-input"
                    type="radio"
                    value="sociology"
                    id="group3"
                    checked={subjectsArr.includes("sociology")}
                  />
                  <label>Sociology</label>
                </div>
              </div>

              <div
                className="col-md-12 col-sm-12"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="col-md-2 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Group 4:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("urdu")]}`}
                    className="form-check-input"
                    type="radio"
                    value="urdu"
                    id="group4"
                    checked={subjectsArr.includes("urdu")}
                  />
                  <label>Urdu</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("sanskrit")]}`}
                    className="form-check-input"
                    type="radio"
                    value="sanskrit"
                    id="group4"
                    checked={subjectsArr.includes("sanskrit")}
                  />
                  <label>Sanskrit</label>
                </div>
              </div>

              <div
                className="col-md-12 col-sm-12"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="col-md-2 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Group 5:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("english")]}`}
                    className="form-check-input"
                    type="radio"
                    value="english"
                    id="group5"
                    checked={subjectsArr.includes("english")}
                  />
                  <label>English</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("history")]}`}
                    className="form-check-input"
                    type="radio"
                    value="history"
                    id="group5"
                    checked={subjectsArr.includes("history")}
                  />
                  <label>History</label>
                </div>
              </div>

              <div
                className="col-md-12 col-sm-12"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div
                  className="col-md-2 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Group 6:
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("economics")]}`}
                    className="form-check-input"
                    type="radio"
                    value="economics"
                    id="group6"
                    checked={subjectsArr.includes("economics")}
                  />
                  <label>Economics</label>
                </div>
                <div className="col-md-2 col-sm-12">
                  <Field
                    name={`${values.subjects[values.subjects.indexOf("philosophy")]}`}
                    className="form-check-input"
                    type="radio"
                    value="philosophy"
                    id="group6"
                    checked={subjectsArr.includes("philosophy")}
                  />
                  <label>Philosophy</label>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {values.registrationType === "Bachelors" &&
          values.courseName !== "BA" &&
          values.courseName !== "--Select--" && (
            <Fragment>
              <div className="col-md-12 col-sm-12">Subjects:</div>
              <div className="col-md-12 col-sm-12 pt-2 mb-2" style={{ textTransform: 'capitalize' }}>
                {formik.values.courseName !== "" && bachelorSubjects}
              </div>
            </Fragment>
          )}
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>First Name</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              disabled={isStudent && values.full_name.first_name !== ""}
              name="full_name.first_name"
              className="form-control"
              placeholder="First Name"
              type="text"
              value={values.full_name.first_name}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Middle Name</label>
            <Field
              name="full_name.middle_name"
              className="form-control"
              placeholder="Middle Name"
              type="text"
              value={values.full_name.middle_name}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Last Name</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="full_name.last_name"
              className={`form-control ${touched?.full_name?.last_name && errors?.full_name?.last_name ? "error" : ""}`}
              placeholder="Last Name"
              type="text"
              value={values.full_name.last_name}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Father's Name </label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="father_name"
              className={`form-control ${touched.father_name && errors.father_name ? "error" : ""}`}
              placeholder="Father's Name"
              type="text"
              value={values.father_name}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Mother's Name </label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="mother_name"
              className={`form-control ${touched.mother_name && errors.mother_name ? "error" : ""}`}
              placeholder="Mother's Name"
              type="text"
              value={values.mother_name}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>
              Date of Birth<span style={{ color: "red" }}>*</span>
            </label>
            <Field
              disabled={isStudent && values.date_of_birth !== ""}
              name="date_of_birth"
              className={`form-control ${touched.date_of_birth && errors.date_of_birth ? "error" : ""}`}
              placeholder="Date of Birth"
              type="date"
              value={values.date_of_birth}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>
              Gender<span style={{ color: "red" }}>*</span>
            </label>
            <Field
              as="select"
              name="gender"
              className={`form-control ${touched.gender && errors.gender ? "error" : ""}`}
              value={values.gender}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Others">Other</option>
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Religion</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="religion"
              className={`form-control ${touched.religion && errors.religion ? "error" : ""}`}
              placeholder="Religion"
              type="text"
              value={values.religion}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>
              Category<span style={{ color: "red" }}>*</span>
            </label>
            <Field
              as="select"
              name="category"
              className={`form-control ${touched.category && errors.category ? "error" : ""}`}
              value={values.category}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="general">General</option>
              <option value="scst">SC/ST</option>
              <option value="obc">OBC</option>
            </Field>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Attach certificate (only if SC/ST)</label>
            <FileUpload
              fileUploadRef={fileUploadRef}
              isDisabled={!Boolean(values.category === "scst")}
              fieldName="document_urls.category_certificate"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.category_certificate}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Do you belong to minority category?</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="isMinority"
              className={`form-control ${touched.isMinority && errors.isMinority ? "error" : ""}`}
              placeholder="Minority?"
              value={values.isMinority}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Field>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label>Do you belong to EWS Category?</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="isEWS_category"
              className={`form-control ${touched.isEWS_category && errors.isEWS_category ? "error" : ""}`}
              value={values.isEWS_category}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Field>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label>Attach certificate (if Yes)</label>
            <FileUpload
              fileUploadRef={fileUploadRef}
              isDisabled={values.isEWS_category !== "Yes"}
              fieldName="document_urls.EWS_category_certificate"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.EWS_category_certificate}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Nationality</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="nationality"
              className={`form-control ${touched.nationality && errors.nationality ? "error" : ""}`}
              placeholder="Nationality"
              value={values.nationality}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Indian">Indian</option>
              <option value="others">Others</option>
            </Field>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>
              Annual family income <span style={{ color: "red" }}>*</span>{" "}
              &nbsp;&#8377;
            </label>
            <Field
              name="annual_family_income"
              className={`form-control ${touched.annual_family_income && errors.annual_family_income ? "error" : ""}`}
              placeholder="Annual family income"
              type="text"
              value={values.annual_family_income}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Domicile(state)</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="domicile"
              className={`form-control ${touched.domicile && errors.domicile ? "error" : ""}`}
              placeholder="Domicile"
              value={values.domicile}
            >
              {stateDistrictList.map((item, index) => {
                return (
                  <option key={`_${index}__${item.state}`} value={item.state}>
                    {item.state}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Domicile certificate number</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="domicile_certitificate_number"
              className={`form-control ${touched.domicile_certitificate_number && errors.domicile_certitificate_number ? "error" : ""}`}
              placeholder="Domicile certitificate no."
              type="text"
              value={values.domicile_certitificate_number}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Attach certificate</label>
            <FileUpload
              fileUploadRef={fileUploadRef}
              fieldName="document_urls.domicile_certificate"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.domicile_certificate}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Do you have aadhar card?</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="isAadharAvailable"
              className={`form-control ${touched.isAadharAvailable && errors.isAadharAvailable ? "error" : ""}`}
              value={values.isAadharAvailable}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Field>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Aadhaar card number</label>
            {values.isAadharAvailable === "Yes" && (
              <span style={{ color: "red" }}>*</span>
            )}
            <Field
              name="aadhar_number"
              className={`form-control ${touched.aadhar_number && errors.aadhar_number ? "error" : ""}`}
              placeholder="xxxx-xxxx-xxxx"
              type="text"
              maxLength="14"
              value={values.aadhar_number}
              disabled={values.isAadharAvailable !== "Yes"}
              onBlur={(e) => onBlurAadhar(e)}
              onFocus={(e) => onFocusAadhar(e)}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label>Attach aadhar card</label>
            {values.isAadharAvailable === "Yes" && (
              <span style={{ color: "red" }}>*</span>
            )}
            <FileUpload
              fileUploadRef={fileUploadRef}
              isDisabled={values.isAadharAvailable !== "Yes"}
              fieldName="document_urls.aadhar_card"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.aadhar_card}
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label>Special Category</label>
            <Field
              as="select"
              name="special_category"
              className={`form-control ${touched.special_category && errors.special_category ? "error" : ""}`}
              value={values.special_category}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="staff">Staff</option>
              <option value="cc">CC</option>
            </Field>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label>Attach certificate</label>
            {values.special_category !== "--Select--" && (
              <span style={{ color: "red" }}>*</span>
            )}
            <FileUpload
              fileUploadRef={fileUploadRef}
              fieldName="document_urls.special_category_certificate"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.special_category_certificate}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  const renderAddressSection = () => {
    const disabled = values.nationality === "--Select--";
    return (
      <Fragment>
        <div className={`card-header add ${classes.heading}`}>
          <h3 className="card-title">Address Information</h3>
        </div>
        <div className="col-md-12 d-flex">
          <div className="mb-2" style={{ textDecoration: "underline", borderLeftStyle: "dotted", paddingLeft: "7.5px" }}>
            Permanent Address
          </div>
          {disabled && (
            <Fragment>
              <i
                className="fa fa-exclamation-circle ml-2 mt-1"
                aria-hidden="true"
                style={{ color: "orange", fontSize: "1.2em" }}
              ></i>
              <p className="ml-1">Select Nationality to enable address</p>
            </Fragment>
          )}
        </div>

        {values.nationality === "Indian" ? (
          <Fragment>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>State</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  as="select"
                  name="state"
                  className="form-control"
                  placeholder="State"
                  value={values.state}
                  disabled={disabled}
                >
                  {stateDistrictList.map((item, index) => {
                    return (
                      <option
                        key={`_${index}__${item.state}`}
                        value={item.state}
                      >
                        {item.state}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>District</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  as="select"
                  name="district"
                  className="form-control"
                  placeholder="District"
                  value={values.district}
                  disabled={disabled}
                >
                  <option value="select">--Select--</option>
                  {stateDistrictList
                    .filter((val) => val.state === values.state)[0]
                    ?.districts?.map((item, index) => {
                      return (
                        <option key={`_${index}__${item}`} value={item}>
                          {item}
                        </option>
                      );
                    })}
                </Field>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>State</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  type="text"
                  name="state"
                  className="form-control"
                  placeholder="State"
                  value={values.state}
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>District</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  type="text"
                  name="district"
                  className="form-control"
                  placeholder="District"
                  value={values.district}
                  disabled={disabled}
                />
              </div>
            </div>
          </Fragment>
        )}

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Pincode</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="pincode"
              className="form-control"
              placeholder="Pincode"
              type="text"
              value={values.pincode}
              disabled={disabled}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label> Address</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="address"
              className="form-control"
              placeholder="Address"
              type="text"
              value={values.address}
              disabled={disabled}
            />
          </div>
        </div>
        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Correspondence Address
        </div>
        <div className="col-md-12 mb-2" style={{ display: "flex" }}>
          <Field
            type="checkbox"
            name="isCorrespondenceAddressSame"
            className="mt-1 mr-2"
            disabled={disabled}
            onChange={(e) => {
              formik.setFieldValue(
                "isCorrespondenceAddressSame",
                e.target.checked
              );
              if (!e.target.checked) {
                formik.setFieldValue("correspondence_state", "");
                formik.setFieldValue("correspondence_district", "");
                formik.setFieldValue("correspondence_address", "");
                formik.setFieldValue("correspondence_pincode", "");
              }
            }}
          />
          Same as permanent address?
        </div>

        {values.nationality === "Indian" ? (
          <Fragment>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>State</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  disabled={values.isCorrespondenceAddressSame || disabled}
                  as="select"
                  name="correspondence_state"
                  className="form-control"
                  placeholder="State"
                  value={values.correspondence_state}
                >
                  {stateDistrictList.map((item, index) => {
                    return (
                      <option
                        key={`_${index}__${item.state}`}
                        value={item.state}
                      >
                        {item.state}
                      </option>
                    );
                  })}
                </Field>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>District</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  as="select"
                  disabled={values.isCorrespondenceAddressSame || disabled}
                  name="correspondence_district"
                  className="form-control"
                  placeholder="District"
                  value={values.correspondence_district}
                >
                  {stateDistrictList
                    .filter(
                      (val) => val.state === values.correspondence_state
                    )[0]
                    ?.districts?.map((item, index) => {
                      return (
                        <option key={`_${index}__${item}`} value={item}>
                          {item}
                        </option>
                      );
                    })}
                </Field>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>State</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  disabled={values.isCorrespondenceAddressSame || disabled}
                  type="text"
                  name="correspondence_state"
                  className="form-control"
                  placeholder="State"
                  value={values.correspondence_state}
                />
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="form-group">
                <label>District</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  type="text"
                  disabled={values.isCorrespondenceAddressSame || disabled}
                  name="correspondence_district"
                  className="form-control"
                  placeholder="District"
                  value={values.correspondence_district}
                />
              </div>
            </div>
          </Fragment>
        )}

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Pincode</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              disabled={values.isCorrespondenceAddressSame || disabled}
              name="correspondence_pincode"
              className="form-control"
              placeholder="Pincode"
              type="text"
              value={values.correspondence_pincode}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label> Address</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              disabled={values.isCorrespondenceAddressSame || disabled}
              name="correspondence_address"
              className="form-control"
              placeholder="Address"
              type="text"
              value={values.correspondence_address}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Phone </label>
            <span style={{ color: "red" }}>*</span>
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">+91</div>
              </div>
              <Field
                disabled={isStudent && values.mobile_number !== ""}
                name="mobile_number"
                className="form-control"
                placeholder="99999 99999"
                type="text"
                maxLength="10"
                value={values.mobile_number}
              />
            </div>
            {values.mobile_number && errors?.mobile_number && (
              <div className="danger" style={{ color: "red" }}>
                Invalid Pattern
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Email Id</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              disabled={isOnlyUpdate || (isStudent && values.email_id !== "")}
              name="email_id"
              className="form-control"
              placeholder="johndoe@example.com"
              type="text"
              value={values.email_id}
            />
            {isStudent && formik.errors.email_id && (
              <div className="danger" style={{ color: "red" }}>
                Kindly contact your school admin to set up your email id
                correctly.
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  const renderEducationSection = () => {
    return (
      <Fragment>
        <div className={`card-header add ${classes.heading}`}>
          <h3 className="card-title">Educational Details</h3>
        </div>
        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Secondary / Metriculation / High School (10th)
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Passing year</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="high_school_passing_year"
              className="form-control"
              placeholder="YYYY"
              type="text"
              value={values.high_school_passing_year}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Board</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="high_school_board"
              className="form-control"
              placeholder="Board name"
              value={values.high_school_board}
            >
              {schoolBoardNamesList.map((item, index) => {
                return (
                  <option
                    key={`_${index}__${item.value}__10th`}
                    value={item.name}
                  >
                    {item.name}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Roll number</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="high_school_roll_number"
              className="form-control"
              placeholder="Roll no."
              type="text"
              value={values.high_school_roll_number}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Maximum marks</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="high_school_max_marks"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.high_school_max_marks}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Marks obtained</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="high_school_marks_obtained"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.high_school_marks_obtained}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>School Name</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="high_school_school_name"
              className="form-control"
              placeholder="School name"
              type="text"
              value={values.high_school_school_name}
            />
          </div>
        </div>
        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Sr. Secondary / Intermediate (12th) / Equivalent
        </div>

        {!isRegisteringForMasters && (
          <Fragment>
            <div className="col-md-6 col-sm-12">
              <div className="form-group">
                <label>Passing status</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  as="select"
                  name="intermediate_passing_status"
                  className="form-control"
                  placeholder="YYYY"
                  value={values.intermediate_passing_status}
                >
                  <option default value="--Select--">
                    --Select--
                  </option>
                  <option value="Passed">Passed</option>
                  <option value="Appearing">Appearing</option>
                </Field>
              </div>
            </div>

            <div className="col-md-6 col-sm-12">
              <div className="form-group">
                <label>School Name</label>
                <span style={{ color: "red" }}>*</span>
                <Field
                  name="intermediate_school_name"
                  className="form-control"
                  placeholder="School name"
                  type="text"
                  value={values.intermediate_school_name}
                />
              </div>
            </div>
          </Fragment>
        )}

        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Passing year</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="intermediate_passing_year"
              className="form-control"
              placeholder=" passing year"
              type="number"
              value={values.intermediate_passing_year}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Board</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="intermediate_board_name"
              className="form-control"
              placeholder="12th Board name"
              value={values.intermediate_board_name}
            >
              {schoolBoardNamesList.map((item, index) => {
                return (
                  <option
                    key={`__${index}__${item.value}__12th`}
                    value={item.name}
                  >
                    {item.name}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Roll no.</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="intermediate_roll_number"
              className="form-control"
              placeholder="12th Roll number"
              type="text"
              value={values.intermediate_roll_number}
            />
          </div>
        </div>

        {(values.intermediate_passing_status === "Passed" ||
          isRegisteringForMasters) && (
            <Fragment>
              <div className="col-md-4 col-sm-12">
                <div className="form-group">
                  <label> maximum marks</label>
                  <span style={{ color: "red" }}>*</span>
                  <Field
                    name="intermediate_max_marks"
                    className="form-control"
                    placeholder="100"
                    type="text"
                    value={values.intermediate_max_marks}
                  />
                </div>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="form-group">
                  <label>Marks obtained</label>
                  <span style={{ color: "red" }}>*</span>
                  <Field
                    name="intermediate_marks_obtained"
                    className="form-control"
                    placeholder="100"
                    type="text"
                    value={values.intermediate_marks_obtained}
                  />
                </div>
              </div>
            </Fragment>
          )}
        {isRegisteringForMasters && (
          <div className="col-md-4 col-sm-12">
            <div className="form-group">
              <label>School Name</label>
              <span style={{ color: "red" }}>*</span>
              <Field
                name="intermediate_school_name"
                className="form-control"
                placeholder="School name"
                type="text"
                value={values.intermediate_school_name}
              />
            </div>
          </div>
        )}
      </Fragment>
    );
  };

  const renderMastersDetailsSection = () => {
    return (
      <Fragment>
        <div className={`card-header add ${classes.heading}`}>
          <h3 className="card-title">Graduation Details</h3>
        </div>
        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Graduation
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>State from where graduated</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="graduation_state"
              className="form-control"
              placeholder="Graduation state"
              value={values.graduation_state}
            >
              {stateDistrictList.map((item, index) => {
                return (
                  <option key={`_${index}__${item.state}`} value={item.state}>
                    {item.state}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-8 col-sm-12">
          <div className="form-group">
            <label>Degree earned university</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="graduation_degree_earned_university"
              className="form-control"
              placeholder="University name"
              type="text"
              value={values.graduation_degree_earned_university}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Graduated year</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="graduation_passing_year"
              className="form-control"
              placeholder="YYYY"
              type="number"
              value={values.graduation_passing_year}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Roll no.</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="graduation_roll_number"
              className="form-control"
              placeholder="Graduation Roll number"
              type="text"
              value={values.graduation_roll_number}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Maximum marks</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="graduation_max_marks"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.graduation_max_marks}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Marks obtained</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              name="graduation_marks_obtained"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.graduation_marks_obtained}
            />
          </div>
        </div>

        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Post Graduation
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>State from where post graduated</label>
            <Field
              as="select"
              name="post_graduation_state"
              className="form-control"
              placeholder="Graduation state"
              value={values.post_graduation_state}
            >
              {stateDistrictList.map((item, index) => {
                return (
                  <option key={`_${index}__${item.state}`} value={item.state}>
                    {item.state}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-8 col-sm-12">
          <div className="form-group">
            <label>Degree earned university</label>
            <Field
              name="post_graduation_degree_earned_university"
              className="form-control"
              placeholder="University name"
              type="text"
              value={values.post_graduation_degree_earned_university}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Post graduated year</label>
            <Field
              name="post_graduation_passing_year"
              className="form-control"
              placeholder="YYYY"
              type="number"
              value={values.post_graduation_passing_year}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Roll no.</label>
            <Field
              name="post_graduation_roll_number"
              className="form-control"
              placeholder="Graduation Roll number"
              type="text"
              value={values.post_graduation_roll_number}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Maximum marks</label>
            <Field
              name="post_graduation_max_marks"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.post_graduation_max_marks}
            />
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <div className="form-group">
            <label>Marks obtained</label>
            <Field
              name="post_graduation_marks_obtained"
              className="form-control"
              placeholder="100"
              type="text"
              value={values.post_graduation_marks_obtained}
            />
          </div>
        </div>

        <div
          className="col-md-12 mb-2"
          style={{ textDecoration: "underline", borderLeftStyle: "dotted" }}
        >
          Other Graduation details
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Qualified degree</label>
            <Field
              as="select"
              name="qualifying_degree"
              className="form-control"
              placeholder="Graduation degree"
              value={values.qualifying_degree}
            >
              {degreeNamesList.map((item, index) => {
                return (
                  <option
                    key={`_${index}__${item.value}__10th`}
                    value={item.name}
                  >
                    {item.name}
                  </option>
                );
              })}
            </Field>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Enroll roll no.</label>
            <Field
              name="enroll_roll_number"
              className="form-control"
              placeholder="Enroll Roll number"
              type="text"
              value={values.enroll_roll_number}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Course system</label>
            <Field
              as="select"
              name="course_system"
              className="form-control"
              value={values.course_system}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="yearly">Yearly</option>
              <option value="semester">Semester</option>
            </Field>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Course duration</label>
            <Field
              as="select"
              name="course_duration"
              className="form-control"
              value={values.course_duration}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="5">5</option>
              <option value="4">4</option>
              <option value="3">3</option>
              <option value="2">2</option>
              <option value="1">1</option>
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderWeightageSection = () => {
    return (
      <Fragment>
        <div className={`card-header add ${classes.heading}`}>
          <h3 className="card-title">Weightage Details</h3>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Weightage-1</label>
            <span style={{ color: "red" }}>*</span>
            <Field
              as="select"
              name="weightage1"
              className={`form-control ${touched.weightage1 && errors.weightage1 ? "error" : ""
                }`}
              placeholder="Weightage 1"
              value={values.weightage1}
            >
              <option default value="--Select--">
                --Select--
              </option>
              <option value="regStuCollege">
                Regular student of St. Andrew's College
              </option>
              <option value="stuInterCollege">
                Student of St. Andrew's Inter College
              </option>
              <option value="none">None</option>
            </Field>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Weightage-2</label>
            <span style={{ color: "red" }}>*</span>
            <div
              role="group"
              aria-labelledby="checkbox-group"
              onChange={(event) => {
                let temp = [...values.weightage2];
                if (!values.weightage2.includes(event.target.value))
                  temp.push(event.target.value);
                else temp = temp.filter((val) => val !== event.target.value);
                formik.setFieldValue("weightage2", temp);
              }}
            >
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="sports-national-level"
                  checked={values.weightage2.includes("sports-national-level")}
                />
                &nbsp; Sport National Level
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="sports-state-inter-university-level"
                  checked={values.weightage2.includes(
                    "sports-state-inter-university-level"
                  )}
                />
                &nbsp; Sport State & Inter University Level
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="sports-district-level"
                  checked={values.weightage2.includes("sports-district-level")}
                />
                &nbsp; Sport District Level
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="NCC-C-grade"
                  checked={values.weightage2.includes("NCC-C-grade")}
                />
                &nbsp; NCC C-Grade
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="NCC-B-grade"
                  checked={values.weightage2.includes("NCC-B-grade")}
                />
                &nbsp; NCC B-Grade
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="NSS-2-camp-and-240-hrs-work"
                  checked={values.weightage2.includes(
                    "NSS-2-camp-and-240-hrs-work"
                  )}
                />
                &nbsp; NSS 2 Camp and 240 hrs work
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="NSS-1-camp-and-240-hrs-work"
                  checked={values.weightage2.includes(
                    "NSS-1-camp-and-240-hrs-work"
                  )}
                />
                &nbsp; NSS 1 Camp and 240 hrs work
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="scout-guides-rovers-ranger"
                  checked={values.weightage2.includes(
                    "scout-guides-rovers-ranger"
                  )}
                />
                &nbsp; Scout/Guides/Rovers/Ranger
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="physical-handicap"
                  checked={values.weightage2.includes("physical-handicap")}
                />
                &nbsp; Physical Handicap
              </label>
              <label className="custom-control custom-checkbox">
                <Field
                  type="checkbox"
                  value="alumni-association"
                  checked={values.weightage2.includes("alumni-association")}
                />
                &nbsp; Alumni/ae Association
              </label>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderPictureAndSignatureSection = () => {
    return (
      <Fragment>
        <div className="card-header add">
          <h6 className="text-danger">
            Only pdf / png / jpeg files allowed, maximum file size can be 20kb
          </h6>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Upload your passport sized picture</label>
            <span style={{ color: "red" }}>*</span>
            <FileUpload
              fileUploadRef={fileUploadRef}
              fieldName="document_urls.passport_photo"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.passport_photo}
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group">
            <label>Upload your signature (scanned)</label>
            <span style={{ color: "red" }}>*</span>
            <FileUpload
              fileUploadRef={fileUploadRef}
              fieldName="document_urls.signature"
              setParentField={formik.setFieldValue}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              formik={formik}
              fileUploadStatus={updateFileUploadStatus}
              uploadedFileUrl={values.document_urls.signature}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  const renderInfoRelatedToRegistrationFormAcceptance = () => {
    if (
      Object.keys(registration_acceptance_time).length > 0 &&
      new Date().getTime() <
      new Date(registration_acceptance_time.start).getTime()
    ) {
      return `Registrations will start on ${moment(
        registration_acceptance_time.start
      ).format("DD MMM YYYY")}.`;
    } else if (
      new Date().getTime() >
      new Date(registration_acceptance_time.end).getTime()
    ) {
      return `Registrations closed on ${moment(
        registration_acceptance_time.end
      ).format("DD MMM YYYY")}. Contact helpline number 8795815610`;
    }
  };

  const renderForm = () => {
    return (
      <Fragment>
        {(isFetchingExistingAdmsnPageInfo || isUserProfileLoading) && isStudent && <span>Loading...<LoaderSpinner /></span>}

        {isStudent && isDataAvailable && (
          <div>
            {isAdmissionPageInfoLoaded && (
              <Fragment>
                <div style={{ display: "flex", marginLeft: "10px", alignItems: "baseline" }}>
                  <p style={{ textDecoration: "underline" }} className="mb-0">
                    Your registration status:
                  </p>{" "}
                  <span className="ml-2" style={isRegistrationCompleted ? { background: "greenyellow" } : { background: "#ffff00b5" }}>
                    {isRegistrationCompleted ? " Complete" : !isRegistrationCompleted ? " Incomplete" : ""}
                  </span>
                  {!isRegistrationCompleted && isDataAvailable && (
                    <div className="d-flex align-items-center">
                      <i
                        className="fa fa-exclamation-circle ml-1"
                        aria-hidden="true"
                        style={{ color: "orange", fontSize: "1.2em", cursor: "pointer" }}
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      ></i>
                      {showTooltip && (
                        <div className="ml-3" style={{ color: "red" }}>
                          <u>Last date for registration is {moment(registration_acceptance_time.end).format("DD MMM YYYY")}</u>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {isRegistrationCompleted &&
                  <div style={{ marginLeft: "10px", alignItems: "baseline", fontWeight: "bold" }}>
                    Complete your entrance fees payment, click  <span style={{ color: 'blue', cursor: "pointer" }} onClick={() => history.push('/collegeFees')}>here</span>.
                  </div>}
                {!isRegistrationCompleted && isStudent && isRegistrationAcceptable && (
                  <div style={{ width: "150%" }}>
                    <marquee
                      behavior="alternate"
                      scrollamount="10"
                      className="text-danger mt-3"
                      loop=""
                    >
                      Consider saving your progress timely to avoid any loss of data.
                    </marquee>
                  </div>
                )}
                {formik.errors.email_id && isStudent && (
                  <div className="text-danger">
                    Your email id is incorrect, kindly contact your school admin to set up your email id correctly.
                  </div>
                )}
              </Fragment>
            )}
            {admissionPageInfoFailed && <p>Error with your network, please try again!</p>}
          </div>
        )}
        {!isDataAvailable && !isFetchingExistingAdmsnPageInfo && (<p className="text-danger">No data available for registration, kindly contact the concerned department!</p>)}
        <br />
        <br />
        {(!isStudent || (isAdmissionsOpen && isRegistrationAcceptable && isStudent && !isRegistrationCompleted && !callingApi)) && (
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit} style={{ display: "contents" }}>
              {!isStudent && !isOnlyUpdate && renderFormTypeSection()}
              {!isStudent && isOnlyUpdate && renderOnlyUpdateSection()}
              {(!isOnlyUpdate || existingAccountFetched) && (
                <Fragment>
                  <hr className="section-hr" />
                  {renderPersonalInfoSection()}
                  <hr className="section-hr" />
                  {renderAddressSection()}
                  <hr className="section-hr" />
                  {renderEducationSection()}
                  <hr className="section-hr" />
                  {(values.registrationType === "Masters" ||
                    isRegisteringForMasters) && (
                      <Fragment>
                        {renderMastersDetailsSection()}
                        <hr className="section-hr" />
                      </Fragment>
                    )}
                  {renderWeightageSection()}
                  <hr className="section-hr" />
                  {renderPictureAndSignatureSection()}
                  <div className="col-sm-12 mt-2 mb-2">
                    {isStudent && formFilledCompletely && (
                      <div>
                        <label className="text-primary">
                          All your madatory details are saved and you are ready for registration.
                        </label>
                      </div>
                    )}
                    {renderFooterButtons()}
                  </div>
                </Fragment>
              )}
            </Form>
          </FormikProvider>
        )}

      </Fragment>
    );
  };

  const renderFooterButtons = () => {
    return (
      <Fragment>
        {(isStudent && !formFilledCompletely) && (
          <button
            onClick={handleFormSubmit}
            className="mr-1 btn btn-primary"
          >
            Save
          </button>
        )}
        {isStudent && formFilledCompletely && (
          <button
            type="submit"
            className="mr-1 btn btn-primary"
          >
            Save & Register
          </button>
        )}
        {!isStudent && (
          <button
            disabled={!formFilledCompletely}
            onClick={handleFormSubmitFaculty}
            type="submit"
            className="mr-1 btn btn-primary"
          >
            {updateExistingRegUser ? `Update` : `Save & Register`}
          </button>
        )}
        <button
          type="reset"
          className="btn btn-outline-secondary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Cancel
        </button>
      </Fragment>
    );
  }

  const renderContent = () => {
    return (
      <Fragment>
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card">
              <div className="card-body">
                <div className="row clearfix">{renderForm()}</div>
                {isStudent && !isOnlyUpdate && <div>{renderInfoRelatedToRegistrationFormAcceptance()}</div>}
              </div>
            </div>
          </div>
        </div>
        {openEventPopup && (
          <Popup
            title={customPopupTitle}
            onCloseClick={() => setopenEventPopup(false)}
            content={customPopupContent}
          />
        )}
      </Fragment>
    );
  };
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}
